import { useEffect } from 'react';
import { DependencyList } from './type.effect.js';

export function useUnmountEffect(fn: () => void, deps: DependencyList = []) {
  return useEffect(() => () => fn(), deps);
}
